import React from "react";
import style from "../../assets/css/global-fields.module.scss";

const GlobalErrorMsgBox = ({errMessage, margin = true}) => {
  return (
    <span
      className={style.globalErrorText}
      style={{
        color: "#d32f2f",
        fontSize: "0.75rem",
        marginLeft: margin ? 14 : 0,
      }}
    >
      {errMessage}
    </span>
  );
};

export default GlobalErrorMsgBox;
